import axios, { AxiosResponse } from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_PLANETDIET_API_URL;
axios.defaults.headers.post['Content-Type'] = 'text/json';

export type ParticipantViewStatus = {
    viewState: string
}

export type ParticipantDetails = {
    name: string
    mitIdUUID: string
    birthDate: string
    email: string
    phoneNumber: string
    infoMeetingDate: string
    v0MeetingDate: string
    v1MeetingDate: string
    v2MeetingDate: string
    v3MeetingDate: string
    v4MeetingDate: string
    participantId: string
}

export type MiniGamesDetails = {
    completedGames: number
    totalGames: number
}

export type CalculateParticipantEligibilityPayload = {
    surveyResponseJson: string // The response of the questionnaire in json format
}

const apiKey = process.env.REACT_APP_PLANETDIET_API_KEY;

export const ParticipantAPI = {
    getParticipantViewStatus: async (token: string|null): Promise<ParticipantViewStatus> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response: any = await axios.get('/participant/participant/viewstate', { headers });
        return response;
    },
    getParticipantDetails: async (token: string|null): Promise<ParticipantDetails> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.get('/participant/participant/details', { headers });
        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },
    calculateParticipantEligibility: async (body: CalculateParticipantEligibilityPayload, token: string): Promise<any> => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response = await axios.post('/participant/participant/calculateeligibility', body, { headers });
        if (response.status === 200) {
            return response.data;
        } else {
            return badStatusError(response);
        }
    },
    getMiniGamesDetails: async (token: string|null): Promise<MiniGamesDetails> => {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Ocp-Apim-Subscription-Key': apiKey,
            };

            const response = await axios.get('/participant/participant/minigames', { headers });

            return response.data;
        } catch (e: any) {
            throw badStatusError(e);
        }
    },
    putMiniGamesDetails: async (completedGames: number, token: string|null): Promise<MiniGamesDetails> => {
        try {
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Ocp-Apim-Subscription-Key': apiKey,
            };

            const response = await axios.put('/participant/participant/minigames', { completedGames: completedGames }, { headers });

            return response.data;
        } catch (e: any) {
            throw badStatusError(e);
        }
    },
    getCanInviteUser: async (token: string|null) => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };

        const response: any = await axios.get('/participant/caninviteuser', { headers });
        return response.date;
    },
    inviteUser: async (token: string|null) => {
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Ocp-Apim-Subscription-Key': apiKey,
        };
        
        const response: any = await axios.post('/participant/inviteuser', {}, { headers });
        return response.date;
    },
};

const badStatusError = (response: AxiosResponse) => {
    throw new Error(`Invalid response: ${response.status} - ${response.data}`);
};